import {Component} from '@angular/core';

@Component({
    selector: 'app-login-redirect',
    templateUrl: './landing-redirect.component.html',
    styleUrls: ['./landing-redirect.component.scss']
})
export class LandingRedirectComponent {
}
